import { FC } from 'react'
import PdfEditorBase from './PdfEditor'
import PdfEditorProvider, { PdfEditorProps } from './PdfEditorProvider'

export const PdfEditor: FC<PdfEditorProps> = ({ templateJSON, saving, onSave, onClose }) => {
  return (
    <PdfEditorProvider
      // eslint-disable-next-line @typescript-eslint/no-unsafe-assignment
      templateJSON={templateJSON}
      saving={saving}
      onSave={onSave}
      onClose={onClose}
    >
      <PdfEditorBase />
    </PdfEditorProvider>
  )
}
